import { formatShortcut } from '@/hooks/useKeyboardShortcuts';
import { cn } from '@/lib/cn';

interface KeyboardHintProps {
  shortcut: string;
  className?: string;
}

/**
 * Displays a keyboard shortcut hint (e.g., "⌘G" or "Ctrl+G")
 * Automatically formats based on the user's platform
 *
 * @example
 * <button>
 *   Generate Draft
 *   <KeyboardHint shortcut="mod+g" />
 * </button>
 */
export function KeyboardHint({ shortcut, className }: KeyboardHintProps) {
  return (
    <span
      className={cn('text-xs text-muted-foreground ml-2 font-mono', className)}
      aria-label={`Keyboard shortcut: ${formatShortcut(shortcut)}`}
    >
      ({formatShortcut(shortcut)})
    </span>
  );
}
